import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import gallery1 from '../images/gallery-1.jpg';
import gallery2 from '../images/home-pic.JPG';
import gallery3 from '../images/gallery-3.jpg';
import gallery4 from '../images/about-pic.jpg';
import gallery5 from '../images/gallery-5.jpg';
import gallery6 from '../images/gallery-6.jpg';
import gallery7 from '../images/gallery-7.jpg';
import gallery8 from '../images/gallery-8.jpg';
import gallery9 from '../images/gallery-9.jpg';
import gallery10 from '../images/gallery-10.jpg';
import gallery11 from '../images/gallery-11.jpg';
import gallery12 from '../images/gallery-12.jpg';
import gallery13 from '../images/gallery-13.jpg';
import gallery14 from '../images/gallery-14.jpg';
import gallery15 from '../images/gallery-15.jpg';
import gallery16 from '../images/gallery-16.jpg';
import gallery17 from '../images/gallery-17.jpg';
import gallery18 from '../images/gallery-18.jpg';
import gallery19 from '../images/gallery-19.jpg';
import gallery20 from '../images/gallery-20.jpg';
import gallery21 from '../images/gallery-21.jpg';
import gallery22 from '../images/gallery-22.jpg';
import gallery23 from '../images/gallery-23.jpg';
import gallery24 from '../images/gallery-24.jpg';
import gallery25 from '../images/gallery-25.jpg';
import gallery26 from '../images/gallery-26.jpg';
import gallery27 from '../images/gallery-27.jpg';
import gallery28 from '../images/gallery-28.jpg';
import gallery29 from '../images/gallery-29.jpg';
import gallery30 from '../images/gallery-30.jpg';
import gallery31 from '../images/gallery-31.jpg';
import gallery32 from '../images/gallery-32.jpg';
import gallery33 from '../images/gallery-33.jpg';
import gallery34 from '../images/gallery-34.jpg';
import gallery35 from '../images/gallery-35.jpg';
import gallery36 from '../images/gallery-36.jpg';
import gallery37 from '../images/gallery-37.jpg';
import gallery38 from '../images/gallery-38.jpg';
import gallery39 from '../images/gallery-39.jpg';
import gallery40 from '../images/gallery-40.jpg';
import gallery41 from '../images/gallery-41.jpg';
import gallery42 from '../images/gallery-42.jpg';
import gallery43 from '../images/gallery-43.jpg';
import gallery44 from '../images/gallery-44.jpg';
import gallery45 from '../images/gallery-45.jpg';
import gallery46 from '../images/gallery-46.jpg';
import gallery47 from '../images/gallery-47.jpg';
import gallery48 from '../images/gallery-48.jpg';
import gallery49 from '../images/gallery-49.jpg';
import gallery50 from '../images/gallery-50.jpg';
import gallery51 from '../images/gallery-51.jpg';
import gallery52 from '../images/gallery-52.jpg';
import gallery53 from '../images/gallery-53.jpg';
import gallery54 from '../images/gallery-54.jpg';
import gallery55 from '../images/gallery-55.jpg';
import gallery56 from '../images/gallery-56.jpg';
import gallery57 from '../images/gallery-57.jpg';
import gallery58 from '../images/gallery-58.jpg';
import gallery59 from '../images/gallery-59.jpg';
import gallery60 from '../images/gallery-60.jpg';
import gallery61 from '../images/gallery-61.jpg';
import gallery62 from '../images/gallery-62.jpg';
import gallery63 from '../images/gallery-63.jpg';

function Gallery(props) {
	return (
		<div className='gallery'>
			<style>
				{'.carousel-indicators { bottom: -3rem ; }'}
				{'.gallery-butt { text-decoration: underline dotted; }'}
			</style>
			<Carousel fade>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery27}
						alt='twenty-seventh slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>Capitol Hill Artist Loft</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery28}
						alt='twenty-eighth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>Capitol Hill Artist Loft</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery29}
						alt='twenty-ninth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>Capitol Hill Artist Loft</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery30}
						alt='thirtieth slide'
					/>
					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>Capitol Hill Artist Loft</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery31}
						alt='thirty-first slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>Capitol Hill Artist Loft</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery32}
						alt='thirty-second slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>Capitol Hill Artist Loft</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery33}
						alt='thirty-third slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>Capitol Hill Artist Loft</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery34}
						alt='thirty-fourth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>Capitol Hill Artist Loft</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery35}
						alt='thirty-fifth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>Capitol Hill Artist Loft</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery36}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>Capitol Hill Artist Loft</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery37}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>Bicycle Shop Cash Wrap</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery38}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>Alki Beach Fence</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery39}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>Bellora Condos Kitchen</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery40}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>Bellora Condos Kitchen</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery41}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>The Highlands - Shoreline</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery42}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>Bellora Condos Kitchen</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery43}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>Bellora Condos Kitchen</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery44}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>The Highlands - Shoreline</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery45}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>The Highlands - Shoreline</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery46}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>The Highlands - Shoreline</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery47}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>The Highlands - Shoreline</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery48}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>The Highlands - Shoreline</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery49}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>The Highlands - Shoreline</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery50}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>The Highlands - Shoreline</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery51}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>The Highlands - Shoreline</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery52}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>The Highlands - Shoreline</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery53}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>The Highlands - Shoreline</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery54}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>The Highlands - Shoreline</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery55}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>The Highlands - Shoreline</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery56}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>The Highlands - Shoreline</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery57}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>The Highlands - Shoreline</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery58}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>The Highlands - Shoreline</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery59}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>The Highlands - Shoreline</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery60}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>The Highlands - Shoreline</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery61}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>The Highlands - Shoreline</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery62}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>The Highlands - Shoreline</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery63}
						alt='thirty-sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>The Highlands - Shoreline</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img className='d-block w-100' src={gallery1} alt='First slide' />

					<Carousel.Caption>
						<h3 className='before'>BEFORE</h3>
						<h5>Pacific Grand Condos Kitchen</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img className='d-block w-100' src={gallery2} alt='Second slide' />

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>Pacific Grand Condos Kitchen</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img className='d-block w-100' src={gallery3} alt='Third slide' />

					<Carousel.Caption>
						<h3 className='before'>BEFORE</h3>
						<h5>Olive 8 Condominiums Kitchen</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img className='d-block w-100' src={gallery4} alt='Fourth slide' />

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>Olive 8 Condominiums Kitchen</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img className='d-block w-100' src={gallery5} alt='Fifth slide' />

					<Carousel.Caption>
						<h3 className='before'>BEFORE</h3>
						<h5>Queen Anne Residence Kitchen</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img className='d-block w-100' src={gallery6} alt='Sixth slide' />

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>Queen Anne Residence Kitchen</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img className='d-block w-100' src={gallery7} alt='Seventh slide' />

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>Queen Anne Residence Kitchen</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img className='d-block w-100' src={gallery8} alt='Eighth slide' />

					<Carousel.Caption>
						<h3 className='before'>BEFORE</h3>
						<h5>98 Union Condos Bathroom #1</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img className='d-block w-100' src={gallery9} alt='Ninth slide' />

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>98 Union Condos Bathroom #1</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img className='d-block w-100' src={gallery10} alt='Tenth slide' />

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>98 Union Condos Bathroom #1</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img className='d-block w-100' src={gallery11} alt='Eleventh slide' />

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>98 Union Condos Bathroom #2</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img className='d-block w-100' src={gallery12} alt='Twelfth slide' />

					<Carousel.Caption>
						<h3 className='before'>BEFORE</h3>
						<h5>98 Union Condos Bathroom #3</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery13}
						alt='Thirteenth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>98 Union Condos Bathroom #3</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery14}
						alt='Fourteenth slide'
					/>

					<Carousel.Caption>
						<h3 className='before'>BEFORE</h3>
						<h5>98 Union Condos Shower #4</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery15}
						alt='Fifteenth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>98 Union Condos Shower #4</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery16}
						alt='Sixteenth slide'
					/>

					<Carousel.Caption>
						<h3 className='before'>BEFORE</h3>
						<h5>Bellora Condos Kitchen</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery17}
						alt='Seventeenth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>Bellora Condos Kitchen</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery18}
						alt='Eighteenth slide'
					/>

					<Carousel.Caption>
						<h3 className='before'>BEFORE</h3>
						<h5>Entire 5,770 Square Foot House at The Highlands Paint</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery19}
						alt='Nineteenth slide'
					/>

					<Carousel.Caption>
						<h3 className='before'>BEFORE</h3>
						<h5>Living Room at The Highlands Paint</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery20}
						alt='Twentieth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>Living Room at The Highlands – 1 Paint</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery21}
						alt='Twenty First slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>Living Room at The Highlands – 2 Paint</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery22}
						alt='Twenty Second slide'
					/>

					<Carousel.Caption>
						<h3 className='before'>BEFORE</h3>
						<h5>
							1st & 2nd floor decks at The Highlands - Water Intrusion Repair
						</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery23}
						alt='Twenty Third slide'
					/>

					<Carousel.Caption>
						<h3 className='during'>DURING</h3>
						<h5>
							1st & 2nd floor decks at The Highlands – 1 Water Intrusion Repair
						</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery24}
						alt='Twenty Fourth slide'
					/>

					<Carousel.Caption>
						<h3 className='during'>DURING</h3>
						<h5>
							1st & 2nd floor decks at The Highlands – 2 Water Intrusion Repair
						</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery25}
						alt='Twenty Fifth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>
							1st & 2nd floor decks at The Highlands – 1 Water Intrusion Repair
						</h5>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img
						className='d-block w-100'
						src={gallery26}
						alt='Twenty Sixth slide'
					/>

					<Carousel.Caption>
						<h3 className='after'>AFTER</h3>
						<h5>
							1st & 2nd floor decks at The Highlands – 2 Water Intrusion Repair
						</h5>
					</Carousel.Caption>
				</Carousel.Item>
			</Carousel>
		</div>
	);
}

export default Gallery;
